import entryAxions from '../../assets/js/entry.axions.api';
// 引入base64.js

// 引入axios
import axios from 'axios';

//
import globalConfig from '../../assets/js/config.file';
import GLOBAL from '../../assets/js/Global.js'
/* public--- */
const PublicFun = {};
//mui

// 处理数组
PublicFun.evil = function ( fn ){
    var Fn = Function; //一个变量指向Function，防止有些前端编译工具报错
    return new Fn('return ' + fn)();
}
//

PublicFun.getData =  (msg,type,url,data,callback) => {
  let lang = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'mm_MY';
  var headsmsg={'X-Requested-With': 'XMLHttpRequest','Locale':lang};
  let token_arr="";
  let access_token="";

  if(msg==2){
       token_arr=GLOBAL.fetch("token");
       access_token=token_arr['access_token'];
    headsmsg={'X-Requested-With': 'XMLHttpRequest', Authorization: 'Bearer '+access_token,'Locale':lang};
  }else if(msg==3){
    token_arr=GLOBAL.fetch("token");
    access_token=token_arr['access_token'];
    headsmsg={'Content-Type': 'multipart/form-data','X-Requested-With': 'XMLHttpRequest', Authorization: 'Bearer '+access_token,'Locale':lang};
  }
  const instance = axios.create({
    headers: headsmsg,
  });


  if(type=='post'){
    entryAxions.apiRequest([instance, {
        // 接口路径
        url: globalConfig.apiUrl + url,

        /* encrypt: base64.Base64.encode,      */    // 是否base64编译 ,不编译为空
        data: data, // 发送数据

      }], callback
    )
  }else if(type=='get'){
    entryAxions.apiUser([instance, {
        // 接口路径
        url: globalConfig.apiUrl + url,

        /* encrypt: base64.Base64.encode,      */    // 是否base64编译 ,不编译为空
        data: data, // 发送数据

      }], callback
    )
  }else if(type=="put"){
    entryAxions.apiPut([instance, {
        // 接口路径
        url: globalConfig.apiUrl + url,

        /* encrypt: base64.Base64.encode,      */    // 是否base64编译 ,不编译为空
        data: data, // 发送数据

      }], callback
    )
  }else if(type=='delete'){
    entryAxions.apiDelete([instance, {
        // 接口路径
        url: globalConfig.apiUrl + url,

        /* encrypt: base64.Base64.encode,      */    // 是否base64编译 ,不编译为空
        data: data, // 发送数据

      }], callback
    )
  }else if(type=='file'){
    entryAxions.apiFile([instance, {
        // 接口路径
        url: globalConfig.apiUrl + url,

        /* encrypt: base64.Base64.encode,      */    // 是否base64编译 ,不编译为空
        data: data, // 发送数据

      }], callback
    )
  }else if(type=='files'){
    entryAxions.apiFiles([instance, {
        // 接口路径
        url: globalConfig.apiUrl + url,

        /* encrypt: base64.Base64.encode,      */    // 是否base64编译 ,不编译为空
        data: data, // 发送数据

      }], callback
    )

  }
}
PublicFun.spread=(url,tyep,data)=>{
  let lang = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'mm_MY';
  let token_arr=GLOBAL.fetch("token");
  let access_token=token_arr['access_token'];
  var headsmsg={'X-Requested-With': 'XMLHttpRequest', Authorization: 'Bearer '+access_token,'Locale':lang};
  var urs='';
  if(tyep=='get'){
     urs=axios.get(globalConfig.apiUrl+url+data,{headers:headsmsg});
  }
  return urs;

}
PublicFun.all=(arr,callback)=>{
  Promise.all(arr)
    .then(function (acct) {
      callback(acct)
    })
    .catch(err=>{
      callback(err)
    })
}

/*var instance = axios.create({
  headers: {'X-Requested-With': 'XMLHttpRequest'}
});*/
//
export default PublicFun;



// WEBPACK FOOTER //
// ./src/assets/js/public.fun.js